import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	cannedResponseToolbarButton: {
		id: 'canned-response-extension.canned-response-toolbar-button.canned-response-toolbar-button',
		defaultMessage: 'Canned responses',
		description: 'Editor Toolbar Button Text for Canned Response',
	},
});
